import { render, staticRenderFns } from "./VersionEditDialog.vue?vue&type=template&id=5b57913e&scoped=true"
import script from "./VersionEditDialog.vue?vue&type=script&lang=js"
export * from "./VersionEditDialog.vue?vue&type=script&lang=js"
import style0 from "./VersionEditDialog.vue?vue&type=style&index=0&id=5b57913e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b57913e",
  null
  
)

export default component.exports